import DataRoomInterestQuestionModal from './DataRoomInterestQuestionModal.component';

export default DataRoomInterestQuestionModal;